import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'

interface ProtectedRouteProps {
  children: React.ReactNode
  requireAdmin?: boolean
}

export function ProtectedRoute({ children, requireAdmin = false }: ProtectedRouteProps) {
  const { user, session, profile, isAdmin, loading } = useAuth()
  const location = useLocation()

  console.log('🛡️ ProtectedRoute check:', { 
    loading, 
    hasUser: !!user, 
    hasSession: !!session, 
    hasProfile: !!profile, 
    isAdmin, 
    requireAdmin,
    path: location.pathname
  })

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0a0a0a]">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 border-2 border-amber-500/30 border-t-amber-500 rounded-full animate-spin" />
          <p className="text-white/50 text-sm tracking-wider uppercase">Cargando...</p>
        </div>
      </div>
    )
  }

  // If no user and no session, redirect to login
  if (!user && !session) {
    console.log('❌ No user or session, redirecting to login')
    return <Navigate to="/configurador/login" replace />
  }

  // If user exists and this is an admin route
  if (requireAdmin) {
    // If profile is still loading (was in timeout), keep waiting - don't redirect yet
    // But isAdmin should be loaded by now, so if it's false, redirect
    if (!isAdmin) {
      console.log('❌ User is not admin, redirecting to configurador')
      return <Navigate to="/configurador" replace />
    }
    // Profile loaded and user IS admin
    console.log('✅ Access granted to admin area')
    return <>{children}</>
  }

  // Non-admin routes - user just needs to be logged in
  console.log('✅ Access granted')
  return <>{children}</>
}
